import { styled } from '@mui/material';
import type { ReactNode } from 'react';

const ResilienceLayout = ({ children }: { children: ReactNode }) => {
  return <StyledContainer data-testid="layout">{children}</StyledContainer>;
};

const StyledContainer = styled('div')({
  display: 'grid',
  margin: '0px 4px',
  height: '100%',
});

export default ResilienceLayout;
